import { Injectable } from '@angular/core';
import { SubscriptionPlans } from './user/user.model';
import { safeGtagEvent } from '../shared/util/integrations';
import { MenuGroupType } from '../map/map.component';

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  constructor() {}

  public logSubscriptionGetStarted(
    plan: SubscriptionPlans,
    monthly: boolean,
    promoCode: string | null
  ) {
    try {
      // @ts-ignore
      safeGtagEvent('SUBSCRIPTION_GET_STARTED', {
        subscription_plan: plan,
        subscription_period: monthly ? 'MONTHLY' : 'YEARLY',
        subscription_promo_code: promoCode,
      });
    } catch (e) {
      console.error(e);
    }
  }

  public logSubscriptionToPayment(
    plan: SubscriptionPlans,
    monthly: boolean,
    promoCode: string | null
  ) {
    safeGtagEvent('SUBSCRIPTION_TO_PAYMENT', {
      subscription_plan: plan,
      subscription_period: monthly ? 'MONTHLY' : 'YEARLY',
      subscription_promo_code: promoCode,
    });
  }

  public logSeeAllIndicators(plan: SubscriptionPlans) {
    safeGtagEvent('PROFILE_SUBSCRIPTION_ALL_INDICATORS', {
      subscription_plan: plan,
    });
  }

  public logSampleReportClicked(plan: SubscriptionPlans) {
    safeGtagEvent('PROFILE_SUBSCRIPTION_SAMPLE_REPORT', {
      subscription_plan: plan,
    });
  }

  public logToggleSubscriptionPeriod(monthly: boolean) {
    safeGtagEvent('PROFILE_SUBSCRIPTION_PERIOD_TOGGLE', {
      subscription_period: monthly ? 'MONTHLY' : 'YEARLY',
    });
  }

  public logClicksReachedLimit() {
    safeGtagEvent('FREE_CLICKS_LIMIT_REACHED', {});
  }

  public logReportOrderTypeConfirmed() {
    safeGtagEvent('ORDER_REPORT_CONFIRM_TYPE', {});
  }

  public logReportOrderLocationConfirmed() {
    safeGtagEvent('ORDER_REPORT_CONFIRM_LOCATION', {});
  }

  logReportToPayment(priceCents: number) {
    safeGtagEvent('ORDER_REPORT_TO_PAYMENT', {
      value: priceCents / 100, // Standard GA4 parameter
      currency: 'USD',
    });
  }

  logFreeReportOrder() {
    safeGtagEvent('FREE_REPORT_ORDER', {});
  }

  logCompareLocationsClick(from: 'map' | 'compare-page') {
    safeGtagEvent('COMPARE_CLICK', {
      compare_source: from,
    });
  }

  logMenuGroupChanged(group: MenuGroupType) {
    safeGtagEvent('MENU_GROUP_CHANGED', {
      menu_group: group,
    });
  }
}
